/**
 * Expose isString
 */

module.exports = isString['default'] = isString

/**
 * Check if string
 * @param  {Mixed}  value
 * @return {Boolean}
 */
function isString (value) {
  return typeof value === 'string'
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/is-string/lib/index.js
// module id = ./node_modules/@f/is-string/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons